import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyWebNotification extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} customFrameClass={"email-notifcation-container"} notificationType={"web"} pageTitle={"Web Notification"} formname={"notifications"} customClass={"field-customization-container legacy-settings-viewer"} />
        );
    }
}

export default LegacyWebNotification;